<template lang="pug">
  v-dialog(v-model='dialogDetalleProOrd', persistent='', max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.sub-head Detalles
      v-divider
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined readonly v-model='formOrden.codigoOrd' label='Código')
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(v-if="formOrden.proveedorOrd" dense outlined readonly v-model='formOrden.proveedorOrd.nombre' label='Proveedor')
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined readonly v-model='formOrden.fec_emis' label='Fecha emisión')
                  v-col(cols='12' md='12')
                    v-data-table.elevation-6(:headers='headersPro' :items='formOrden.articulos' :footer-props="{itemsPerPageText: 'Productos por página'}")
                      template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                      template(v-slot:no-data)
                        h2 Tabla vacía
      v-card-actions
        v-spacer
        v-btn(color='error' style='width: 10%' small dark @click='closeDetalleProOrd()')
          v-icon mdi-close
          | Salir
</template>

<script>
export default {
  props: ['dialogDetalleProOrd', 'FormDetalleProOrd'],
  data: () => ({
    headersPro: [
      { text: 'Código', align: 'center', value: 'co_art' },
      { text: 'Producto', align: 'center', value: 'art_des' },
      { text: 'Cantidad Pedido', align: 'center', value: 'total_art', sortable: false},
      { text: 'Total Neto ($)', align: 'center', value: 'reng_neto', sortable: false }
    ],
    formOrden: {}
  }),

  watch: {
    FormDetalleProOrd (val) {
      if (Object.keys(val).length !== 0) {
        this.formOrden = val
      }
    }
  },

  methods: {
    closeDetalleProOrd () {
      this.$emit('closeDetalleProOrd')
    }
  }
}
</script>
